import type { User, UserRole, UserCapabilities } from '../stores/authStore';

const emptyCaps: UserCapabilities = {
  external_customer: false,
  can_create_plant: false,
  can_browse_marketplace: false,
  can_procure_plant: false,
  can_batch_procure: false,
  use_external_menu: false,
};

export function capabilitiesForRole(role?: UserRole | string | null): UserCapabilities {
  if (role === 'person' || role === 'enterprise') {
    return {
      external_customer: true,
      can_create_plant: true,
      can_browse_marketplace: false,
      can_procure_plant: true,
      can_batch_procure: false,
      use_external_menu: true,
    };
  }
  if (role === 'investor') {
    return {
      external_customer: true,
      can_create_plant: false,
      can_browse_marketplace: true,
      can_procure_plant: true,
      can_batch_procure: true,
      use_external_menu: true,
    };
  }
  if (role === 'buyer') {
    return {
      external_customer: true,
      can_create_plant: false,
      can_browse_marketplace: true,
      can_procure_plant: true,
      can_batch_procure: false,
      use_external_menu: true,
    };
  }
  if (role === 'operator') {
    return {
      external_customer: false,
      can_create_plant: true,
      can_browse_marketplace: true,
      can_procure_plant: true,
      can_batch_procure: true,
      use_external_menu: false,
      can_directly_mutate_plant: true,
      can_build_on_behalf_of_customer: true,
      can_claim_plant_ownership: true,
      can_approve_plant_deletion: true,
      can_approve_asset_transfer: true,
    };
  }
  if (role === 'admin' || role === 'dev') {
    return {
      external_customer: false,
      can_create_plant: true,
      can_browse_marketplace: true,
      can_procure_plant: true,
      can_batch_procure: true,
      use_external_menu: false,
      can_directly_mutate_plant: true,
      can_build_on_behalf_of_customer: true,
      can_claim_plant_ownership: true,
      can_arbitrate: true,
      can_approve_plant_deletion: true,
      can_approve_asset_transfer: true,
      can_manage_accounts: true,
    };
  }
  return emptyCaps;
}

export function getUserCapabilities(user?: User | null): UserCapabilities {
  return user?.capabilities ?? capabilitiesForRole(user?.role);
}
